import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { startWith } from 'rxjs';
import { loadLanguageData } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';

@Component({
  selector: 'app-product-catalog',
  templateUrl: './product-catalog.component.html',
  styleUrls: ['./product-catalog.component.css']
})
export class ProductCatalogComponent implements OnInit {
  public lang: any = {};
  languageData$: any;
  selectedLanguage: string;
  filterPlanslist: Array<any> = [];
  // plans: string[] = []; 
  selectedPlan: string = '';
  selectedRegion: string = 'Canada';
  selectedProductCatelog: string = 'V44(A)  (C ) 01/01/25  (E) 31/05/25  Notes';
  selectedFilterplan: string = 'All Plans';
  selectedAction: string = 'Display Catalog';

  actions: string[] = [
    'Edit Catalog',
    'Create New Catalog',
    'Display Catalog'
  ];

  regions: string[] = ['Canada', 'USA', '...'];
  filterplans: string[] = [
    "All Plans",
    "Health & Dental (1,853)",
    "Private Health (xxxx)",
    "Wellness (xxxx)",
    "Life and Disability (xxxx)",
    "Travel Protection (xxxx)",
    "Private Health (xxxx)"
  ];


  productCatelogs: string[] = [' V44(A)  (C ) 01/01/25  (E) 31/05/25  Notes', 'V43(B)  (C ) 01/01/24  (E) 31/05/24  Archived', 'V42(A)  (C ) 01/01/23  (E) 31/05/23  Legacy']

  plans: string[] = [
    'Health & Dental',
    'Wellness',
    'Travel',
    'Private Health',
    'TeleMedicine',
    'Life & CI',
    'Bundle 1',
    'Bundle'
  ];
  isDropdownOpen: boolean = false;
  hovered: string = '';

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectFilterPlan(plan: string) {
    this.selectedFilterplan = plan;
    this.isDropdownOpen = false;
  }


  datarecords: string[] = [
    'Health & Dental',
    'Wellness',
    'Travel',
    'Private Health',
    'TeleMedicine',
    'Life & CI',
    'Bundle 1',
    'Bundle'

  ];
  notes = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];

  tableData = [
    { value1: 'Value 1', date1: '01/01/25', date2: '31/05/25' },
    // { value1: 'Value 3', date1: '01/02/25', date2: '01/06/25', value2: 'Value 4', selectedNote: 'Option 2' },
    // { value1: 'Value 5', date1: '15/03/25', date2: '31/07/25', value2: 'Value 6', selectedNote: 'Option 3' }
  ];

  // This function is called when the region changes
  onRegionChange() {
    console.log("Selected Region: ", this.selectedRegion);
  }


  constructor(private store: Store<{ languageData: [] }>, private http: HttpClient,) {
    this.languageData$ = store.select(selectLanguageData);
  }


  ngOnInit(): void {
    this.getLanguageTokens();

    // example
    this.http.get('/endpoint',).subscribe((response: any) => {
      console.log(response)
      this.plans = response?.plans ?? []
    })
  }

  public getLanguageTokens() {
    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        }, 0)
      }
    })
  }

  public getFilterPlans() {


  }

}
